import { create } from 'zustand';
import debounce from '../helpers/debounce';
import {
  fetchFeaturedCoins,
  fetchTrendingCoins,
  getStabilityNotice,
  searchCoins,
} from '../api/coingecko';

const SEARCH_MIN_LENGTH = 2;

const homeStore = create((set, get) => ({
  featured: [],
  coins: [],
  trending: [],
  query: '',
  loading: false,
  searching: false,
  searched: false,
  error: '',
  searchError: '',
  homeNotice: '',
  searchNotice: '',
  updatedAt: null,

  setQuery: (event) => {
    const query = event.target.value;
    set({ query, searchError: '' });
    get().searchCoins(query);
  },

  bootstrap: async () => {
    set({ loading: true, error: '', homeNotice: '' });

    const [featuredResult, trendingResult] = await Promise.allSettled([
      fetchFeaturedCoins(),
      fetchTrendingCoins(),
    ]);

    const nextState = {
      featured: get().featured,
      trending: get().trending,
      coins: get().coins,
      loading: false,
      error: '',
      homeNotice: '',
      updatedAt: Date.now(),
    };

    if (featuredResult.status === 'fulfilled') {
      nextState.featured = featuredResult.value.data;
      nextState.homeNotice = getStabilityNotice(featuredResult.value.meta);
    }

    if (trendingResult.status === 'fulfilled') {
      nextState.trending = trendingResult.value.data;
      if (!get().query.trim()) {
        nextState.coins = trendingResult.value.data;
      }

      if (!nextState.homeNotice) {
        nextState.homeNotice = getStabilityNotice(trendingResult.value.meta);
      }
    }

    if (!nextState.featured.length && !nextState.trending.length) {
      nextState.error =
        (featuredResult.status === 'rejected' && featuredResult.reason?.message) ||
        (trendingResult.status === 'rejected' && trendingResult.reason?.message) ||
        'Unable to load market data right now.';
    }

    set(nextState);
  },

  searchCoins: debounce(async (rawQuery) => {
    const query = rawQuery.trim();
    const { trending } = get();

    if (query.length < SEARCH_MIN_LENGTH) {
      set({
        coins: trending,
        searching: false,
        searched: false,
        searchError: '',
        searchNotice: '',
      });
      return;
    }

    set({
      searching: true,
      searched: false,
      searchError: '',
      searchNotice: '',
    });

    try {
      const result = await searchCoins(query);

      if (get().query.trim() !== query) {
        return;
      }

      set({
        coins: result.data,
        searching: false,
        searched: true,
        searchError: '',
        searchNotice: getStabilityNotice(result.meta),
      });
    } catch (error) {
      if (get().query.trim() !== query) {
        return;
      }

      set({
        coins: trending,
        searching: false,
        searched: false,
        searchError: error.message,
        searchNotice: '',
      });
    }
  }, 400),
}));

export default homeStore;
